module.exports = __webpack_public_path__ + "media/images/equipments-img-02-0e27507274d0446d3b0c2f5cc5cb9111.jpg";